import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { AchievementCard } from './types';
import { prepareAchivementCard } from './prepareAchievementCard';

/**
 * Prepares data for multiple AchievementCard components
 *
 * @method getAchievementProgress
 * @memberof Gamification
 * @returns {Promise<AchievementCard[]>} - Array of prepared AchievementCard properties
 */

export const getAchievementProgress = async (): Promise<AchievementCard[]> => {
  const url = `${Constants.BACKEND_URL}/achievements/get-achievement-progress`;
  return httpGet(url, {})
    .then((response) => {
      if (response && response.data) {
        const { achievement_summary } = response.data;
        const processedCardProps = [];

        for (const userAchievement of achievement_summary) {
          processedCardProps.push(prepareAchivementCard(userAchievement));
        }

        return processedCardProps;
      }
      return [];
    })
    .catch((error) => {
      throw Error(error);
    });
};
